import FunnelPage from "./FunnelPage";

export default function FunnelCoaching() {
  return (
    <FunnelPage
      funnelKey="coaching_funnel"
      eyebrow="Christy Vonta Coaching & Consulting"
      headline="This is where transformation gets personal."
      body="Dr. Christy Vonta's coaching practice is by application only. A brief intake helps us understand whether her one-to-one container, group cohort, or retreat experience is the right fit for you."
      comingNext="The full coaching diagnostic is being finalized"
      noteLabel="What are you carrying right now? (optional)"
      notePlaceholder="Share as much or as little as feels right…"
      testidPrefix="funnel-coaching"
    />
  );
}
